type Props = {
  type?: string;
  modifier?: string;
  size?: number;
  /** Stroke width — bumps up for big inset usage. */
  strokeWidth?: number;
};

/**
 * Arrow / flag / roundabout glyph for an OSRM maneuver. Shared between
 * the NavStrip (small) and the ManeuverInset (large overlay).
 */
export function ManeuverIcon({ type, modifier, size = 48, strokeWidth = 4 }: Props) {
  const rot = rotationFor(modifier);
  const half = size / 2;
  if (type === "arrive") {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden>
        <path
          d="M14 8 v32 M14 8 h22 l-4 6 l4 6 h-22"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={strokeWidth * 0.6}
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (type === "roundabout" || type === "rotary") {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48"
        fill="none" stroke="currentColor"
        strokeWidth={strokeWidth * 0.9} strokeLinecap="round" strokeLinejoin="round"
        aria-hidden
      >
        <circle cx="24" cy="24" r="9" />
        <path d="M24 42 L24 33 M14 16 l8 -8 l8 8" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden>
      <g transform={`rotate(${rot} ${half * 48 / size} ${half * 48 / size})`}>
        <path
          d="M24 6 L24 38 M24 6 L16 14 M24 6 L32 14"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

function rotationFor(modifier?: string) {
  switch (modifier) {
    case "left": return -90;
    case "right": return 90;
    case "slight left": return -45;
    case "slight right": return 45;
    case "sharp left": return -135;
    case "sharp right": return 135;
    case "uturn": return 180;
    case "straight":
    default: return 0;
  }
}
